export const ApiResponseMessage = ({ response }) => (
    response.message && (
        <div className={`px-4 py-2 text-center text-sm ${response.type === 'success'
                ? 'text-green-600 bg-green-100'
                : 'text-red-600 bg-red-100'
            } rounded-md mx-4`}>
            {response.message}
        </div>
    )
);